module.exports = __webpack_public_path__ + "img/truck-location.ea3aba13.svg";